import { render, staticRenderFns } from "./childEdit.vue?vue&type=template&id=63f1100d&scoped=true&"
import script from "./childEdit.vue?vue&type=script&lang=js&"
export * from "./childEdit.vue?vue&type=script&lang=js&"
import style0 from "./childEdit.vue?vue&type=style&index=0&id=63f1100d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f1100d",
  null
  
)

export default component.exports